import { Injectable } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { HttpStatus, httpStatusMessages } from "../api/http-status.enum";

@Injectable({
	providedIn: "root",
})
export class NotyService {
	httpStatusMessages = httpStatusMessages;
	hasBroughtForwardNotification = false;

	constructor(private nzNotificationService: NzNotificationService) {}

	httpError(status: HttpStatus, content: string = httpStatusMessages[status]?.message) {
		this.nzNotificationService.error(httpStatusMessages[status]?.title ?? "Error", content, {
			nzDuration: 10000,
			nzClass: "nz-error-notification",
		});
		this.bringForwardNotification();
	}

	httpWarning(status: HttpStatus, content: string = httpStatusMessages[status]?.message) {
		this.nzNotificationService.warning(httpStatusMessages[status]?.title ?? "Warning", content, {
			nzClass: "nz-warning-notification",
		});
		this.bringForwardNotification();
	}

	httpSuccess(status: HttpStatus, content: string = httpStatusMessages[status]?.message) {
		this.nzNotificationService.success(httpStatusMessages[status]?.title ?? "Success", content, {
			nzClass: "nz-success-notification",
		});
		this.bringForwardNotification();
	}

	httpInfo(status: HttpStatus, content: string = httpStatusMessages[status]?.message) {
		this.nzNotificationService.info(httpStatusMessages[status]?.title ?? "Info", content, { nzClass: "nz-info-notification" });
		this.bringForwardNotification();
	}

	error(title?: string, content?: string) {
		this.nzNotificationService.error(title, content, {
			nzDuration: 10000,
			nzClass: "nz-error-notification",
		});
		this.bringForwardNotification();
	}

	warning(title?: string, content?: string) {
		this.nzNotificationService.warning(title, content, { nzClass: "nz-warning-notification" });
		this.bringForwardNotification();
	}

	success(title?: string, content?: string) {
		this.nzNotificationService.success(title, content, { nzClass: "nz-success-notification" });
		this.bringForwardNotification();
	}

	info(title?: string, content?: string) {
		this.nzNotificationService.info(title, content, { nzClass: "nz-info-notification" });
		this.bringForwardNotification();
	}

	private bringForwardNotification() {
		if (this.hasBroughtForwardNotification) return;

		if (document.getElementsByTagName("nz-notification-container")[0]?.parentElement?.parentElement?.style?.zIndex != null) {
			this.hasBroughtForwardNotification = true;
			document.getElementsByTagName("nz-notification-container")[0].parentElement.parentElement.style.zIndex = "1010";
		}
	}
}
